/**
 * /*
 *
 * @format
 * @Description:
 * @Author: changfu
 * @Date: 2020-06-12 09:20:39
 * @LastEditTime: 2020-06-12 09:20:40
 * @LastEditors:
 */
export default {
  applicationResources: {
    application: 'Application',
    selectApplication: 'Select application',
    menu: 'Menu',
    menuDetails: 'Menu details',
    menuInformation: 'Menu information',
    menuNumber: 'Menu number',
    menuName: 'Menu name',
    menuIcon: 'Menu icon',
    menuUrl: 'Menu url',
    save: 'Save',
    buttonName: 'Button name',
    pageElementNumber: 'Page element number',
    state: 'State',
    lastUpdated: 'Last updated',
    enable: 'Enable',
    prohibit: 'Prohibit',
    no: 'No',
    buttonList: 'ButtonList',
    pageElementList: 'Page element list',
    pageElementName: 'Page element name',
  }
};



// WEBPACK FOOTER //
// ./src/config/langs/en_US/applicationResources.js